export default {
  'PresentationDetail.tab.detail': 'Detail',
  'PresentationDetail.tab.notes': 'Notes',
  'PresentationDetail.tab.chat': 'Chat',
  'PresentationNotes.title': 'Notes to presentation',
  'PresentationNotes.hint': 'Notes are saved automatically',
  'PresentationNotes.shareMail': 'Send notes by e-mail',
  'ReportProblemPage.submitButton': 'Report a problem',
  'NewVersionPrompt.message': 'New content is available',
  'NewVersionPrompt.action': 'LOAD',
  'addons.Feedback.sent': 'Send feedback',
  'addons.Feedback.sentOk': 'Thank you for your feedback',
  'addons.Feedback.sentError': 'Error during sending. Try again later.',
  'addons.Chat.loading': 'Chat is loading...',
  'addons.Chat.error': 'Error while loading chag. Try again later.',
  'addons.Chat.offline': 'Chat will load when you get online.',
}



// WEBPACK FOOTER //
// ./src/intl/messages/en.js